import React from "react";
import "./Location.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaPaperPlane, FaClock } from "react-icons/fa";

export default function Location() {
  return (
    <section className="loc-section">
      <h2 className="loc-heading">Visit Our Hospital</h2>

      <div className="loc-wrapper">

        {/* Map Box */}
        <div className="loc-map">
          <a
            href="https://maps.app.goo.gl/ax1PTFfift5ivs6M7"
            target="_blank"
            rel="noopener noreferrer"
            className="map-overlay"
          >
            Open Map
          </a>

          <iframe
            title="clinic-map"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3791.8211629472303!2d75.0219353!3d18.126048000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc47f001c146581%3A0x7d30644ddf72ad4a!2sDr.Chavan%20Multi-speciality%20Hospital!5e0!3m2!1sen!2sin!4v1764514897009!5m2!1sen!2sin" 
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Info Card */}
        <div className="loc-card">

          <div className="loc-title-row">
            <FaMapMarkerAlt className="loc-main-icon" />
            <h3>Dr. Chavan Multispeciality Hospital</h3>
          </div>

          <p className="loc-address">
            Opp. To Irrigation Colony,Kalthan Road – 413106<br />
            Indapur, Dist - Pune, Maharashtra 
          </p>

          {/* <div className="loc-info">
            <FaClock className="loc-icon" />
           <span>
    Mon – Fri: Morning 10:00 AM – 1:00 PM,<br></br> Evening 5:00 PM – 8:00 PM <br />
    Saturday: Morning 10:00 AM – 1:00 PM (Evening Closed) <br />
    Sunday: Morning 10:00 AM – 1:00 PM,<br></br> Evening 5:00 PM – 8:00 PM
  </span>
          </div> */}

          <div className="loc-info">
            <FaPhoneAlt className="loc-icon" />
            <a href="tel:+917249693033">+91 7249693033</a>
          </div>
            <br></br>
          <div className="loc-info">
            <FaPaperPlane className="loc-icon" />
            <a
              href="https://maps.app.goo.gl/ax1PTFfift5ivs6M7"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Directions
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
